import { ctaDesc, ctaTitle } from "@/lib/seo";
import { createFileRoute, notFound } from "@tanstack/react-router";
import VisaProductPage from "@/components/VisaProductPage";
import { visaProductGraph, defaultVisaProductFaqs } from "@/lib/visa-product-schema";
import { BRAND_URL } from "@/lib/brand";

export const Route = createFileRoute("/en/visa/products/$slug")({
  loader: async ({ params }) => {
    const { getVisaProduct } = await import("@/data/visa-products");
    const p = getVisaProduct(params.slug);
    if (!p) throw notFound();
    return { product: p };
  },
  head: ({ loaderData, params }) => {
    if (!loaderData) return { meta: [{ title: ctaTitle("Not found", "/en/visa/products/$slug", "en")}, { name: "robots", content: "noindex" }] };
    const p = loaderData.product;
    const path = `/en/visa/products/${params.slug}`;
    const url = `${BRAND_URL}${path}`;
    const title = `${p.nameEn} (${p.visa.code}) — Thailand visa | ${p.turnaround}`;
    const desc = p.shortDescEn + " · End-to-end Thailand visa application service by NYC Legal — eligibility screening, filing at Immigration / BOI / consulates, follow-up until approval.";
    const faqs = defaultVisaProductFaqs(p, "en");
    return {
      meta: [
        { title: ctaTitle(title, "/en/visa/products/$slug", "en") }, { name: "description", content: ctaDesc(desc, "/en/visa/products/$slug", "en")},
        { property: "og:title", content: ctaTitle(title, "/en/visa/products/$slug", "en")},
        { property: "og:description", content: ctaDesc(desc, "/en/visa/products/$slug", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "product" },
        { property: "og:locale", content: "en_US" },
        { property: "product:price:amount", content: String(p.priceMid) },
        { property: "product:price:currency", content: "THB" },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "en", href: url },
        { rel: "alternate", hrefLang: "th-TH", href: `${BRAND_URL}/visa/products/${params.slug}` },
        { rel: "alternate", hrefLang: "x-default", href: `${BRAND_URL}/visa/products/${params.slug}` },
      ],
      scripts: [{
        type: "application/ld+json",
        children: JSON.stringify(visaProductGraph({ product: p, locale: "en", path, faqs })),
      }],
    };
  },
  notFoundComponent: () => <div className="p-16 text-center">Visa not found</div>,
  component: () => {
    const { product } = Route.useLoaderData();
    return <VisaProductPage product={product} locale="en" faqs={defaultVisaProductFaqs(product, "en")} />;
  },
});
